import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { EmailService } from '../../../../core/api/email.service';
import { EmailTemplateDatasource } from '../../../../shared/datasources/email-template-datasource';
import { EmailTemplate } from '../../../../shared/models';

@Component({
  selector: 'fc-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.scss'],
})
export class EmailTemplatesComponent implements OnInit {
  dataSource: EmailTemplateDatasource;
  displayedColumns: string[] = ['name', 'subject', 'description', 'actions'];

  constructor(readonly emailService: EmailService, readonly router: Router) {
    this.dataSource = new EmailTemplateDatasource();
  }

  ngOnInit() {
    this.emailService.getAllEmailTemplates().subscribe({
      next: (templates: EmailTemplate[]) => {
        this.dataSource.data = [...templates].sort((a, b) => a.name.localeCompare(b.name));
      },
    });
  }

  navigateToTemplateDetails(template?: EmailTemplate): void {
    this.router.navigate(
      ['admin', 'manage', 'email', 'template', 'edit'],
      template ? { queryParams: { templateId: template.id } } : undefined
    );
  }
}
